<script>
import { colors } from '@/config'

export default {

  props: {

    x: {
      type: Number,
      required: true
    },

    y: {
      type: Number,
      required: true
    }

  },

  data () {
    return {
      groundColor: colors.darkGreen
    }
  }

}
</script>

<template>
  <a-plane
    :width="x"
    :height="y"
    :color="groundColor"
    material="roughness: 0.75"
  />
</template>
